import * as React from 'react'
import {createStyles, Paper, Slide, Theme, WithStyles, withStyles, Typography} from '@material-ui/core'
import {WithI18n, withI18n} from '../../i18n/withI18n'
import {sidebarWith} from './SidebarLayout'
import SidebarHr from './SidebarHr'
import SidebarItem from './SidebarItem'
import {connect} from 'react-redux'
import {RootState} from '../../redux/reducer/index'
import {PaletteColor} from '@material-ui/core/styles/createPalette'
import { fetchEnterpriseSelected } from 'src/core/redux/action/accountInfosAction'
import autobind from 'autobind-decorator'
import { compose } from 'redux'
import { formAction } from 'src/core/redux/action/formAction'

export const sidebarPalette = (t: Theme): PaletteColor => t.palette.primary

const styles = (t: Theme) => createStyles({
  root: {
    top: 0,
    left: 0,
    width: sidebarWith,
    paddingTop: t.spacing.unit,
    paddingBottom: t.spacing.unit,
    position: 'fixed',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 0
  },
  head: {
    textAlign: 'center',
    paddingTop: t.spacing.unit * 2,
    paddingBottom: t.spacing.unit * 2,
    display: 'block',
  },
  main: {
    paddingTop: t.spacing.unit,
    paddingBottom: t.spacing.unit,
    flex: 1,
    overflowY: 'auto',
    "&::-webkit-scrollbar": { width: "10px"},
    "&::-webkit-scrollbar-track": { background: "#f1f1f1"},
    "&::-webkit-scrollbar-thumb": { background: "#888"},
    "&::-webkit-scrollbar-thumb:hover": { background: "#555"},
  },
  foot: {
    paddingTop: t.spacing.unit,
    paddingBottom: t.spacing.unit,
  },
  avatar: {
    background: t.palette.divider,
    margin: 'auto',
  },
  logoSidebar:{
    display: 'block',
    margin: '0 auto',
    maxWidth: '150px',
    height: 'auto'
  },
  changeEnterprise: {
    color: t.palette.common.black,
    background: 'transparent',
    borderRight: 0
  },
  disabled: {
    pointerEvents: 'none'
  },
  hr: {
    backgroundColor: `${t.palette.primary.main}`
  }
})

interface IProps extends ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>,
  WithI18n,
  WithStyles<typeof styles> {
  basePath?: string;
  isMenuItemActive?: boolean
}

class Sidebar extends React.Component<IProps, {}> {

  static defaultProps = {
    basePath: '',
  }

  render() {
    const {t, classes, basePath, enterprises, enterprise, isMenuItemActive, context, connectedUser} = this.props
    return (
      <Slide direction="right" in={true} mountOnEnter unmountOnExit>
        <Paper elevation={4} className={classes.root}>
          {context &&
            <header className={classes.head}>
              <img src={context.logo_url} className={classes.logoSidebar} />
            </header>
           }
          <SidebarHr className={classes.hr}/>
          <main className={classes.main}>
          
            <SidebarItem className={classes.disabled}>
              <Typography variant='caption' style={{textTransform: 'uppercase', textAlign: 'center', marginBottom: 8}}>{t.manager_title}</Typography>
            </SidebarItem>

            {isMenuItemActive === true &&
              <SidebarItem to={basePath + '/dashboard'} icon="dashboard">
              Tableau de bord
              </SidebarItem>
            }

            {enterprise && isMenuItemActive === true &&
              <SidebarItem to={basePath + '/enterprise/'} icon="business">
                {enterprise.name}
              </SidebarItem>
            }

            {enterprises && enterprises.length >= 2 &&
              <SidebarItem className={classes.changeEnterprise} to={'/'} onClick={this.changeEnterprise} icon="swap_horiz">
                {t.Menu_changeEnterprise}
              </SidebarItem>
            }

            {isMenuItemActive === true &&
              <SidebarItem to={basePath + '/operations'} icon="account_balance">
                {t.operations}
              </SidebarItem>
            }


            {isMenuItemActive === true &&
              <SidebarItem to={basePath + '/products'} icon="widgets">
                {t.products}
              </SidebarItem>
            } 

            {isMenuItemActive === true && connectedUser.read_only_access === false &&
              <SidebarItem to={basePath + '/cotations'} icon="record_voice_over">
                {t.cotations}
              </SidebarItem>
            }

            {isMenuItemActive === true &&
              <SidebarItem to={basePath + '/signature'} icon="gesture">
                {t.signatures_documents}
              </SidebarItem>
            }

            {isMenuItemActive === true &&
              <SidebarItem to={basePath + '/kyc'} icon="send">
                {t.send_document}
              </SidebarItem>
            }

            {isMenuItemActive === true &&
              <SidebarItem to={basePath + '/market-indicators'} icon="timeline">
                {t.market_indicators}
              </SidebarItem>
            }

            {isMenuItemActive === true &&
              <SidebarItem to={basePath + '/eco-watch'} icon="language">
                {t.eco_watch}
              </SidebarItem>
            }

            {isMenuItemActive === true &&
              <SidebarItem to={basePath + '/bulletin'} icon="chrome_reader_mode">
                {t.Menu_newsletter}
              </SidebarItem>
            }

            {isMenuItemActive === true &&
              <SidebarItem to={basePath + '/news'} icon="list_alt">
                {t.news}
              </SidebarItem>
            }

            <SidebarItem to={basePath + '/contact'} icon="question_answer">
              {t.contact}
            </SidebarItem>

            {this.domiwebSidebarRender()}

            <SidebarItem href="/logout" icon="power_settings_new">
              {t.logout}
            </SidebarItem>
          </main>
        </Paper>
      </Slide>
    )
  }

  @autobind
  domiwebSidebarRender(){
    const { enterprise } = this.props;
    let label;
    let url;
    if(enterprise && enterprise.efs_name === "CMSO"){
      label = "Espace Client CMSO"
      url = "https://espacepro.cmso.com/auth/login"
    } else if(enterprise && enterprise.efs_name === "CMB"){
      if(enterprise.business_provider_network === "ARKEA BEI"){
        label = "Espace Client ABEI"
        url = "https://mabanque.arkea-banque-ei.com/auth/login"
      } else {
        label = "Espace Client CMB"
        url = "https://espacepro.cmb.fr/auth/login"
      }
    } else if (enterprise && enterprise.efs_name === "ARKEA BEI") {
        label = "Espace Client ABEI"
        url = "https://mabanque.arkea-banque-ei.com/auth/login"
    }
    return (!!label && !!url) ? (
      <SidebarItem href={url} icon="home" target="_blank">
        {label}
      </SidebarItem>
    ) : ''
  }

  @autobind
  changeEnterprise(){
    this.props.resetForm();
    this.props.getConsumer(null);
  }
}


const state2props = (state: RootState) => ({
  context: state.accountInfo.context,
  connectedUser: state.accountInfo.connectedUser,
  enterprises: state.accountInfo.enterprises,
  enterprise: state.accountInfo.enterpriseSelected
})

const dispatch2props = (dispatch: any, ownProps: any) => ({
  resetForm: () => dispatch(formAction.resetForm()),
  getConsumer: (enterprise: any) => dispatch(fetchEnterpriseSelected(enterprise)),
})


export default compose(
  withI18n,
  withStyles(styles),
  connect(state2props, dispatch2props, null, {pure:false})
)(Sidebar)



// WEBPACK FOOTER //
// ./src/core/component/Sidebar/Sidebar.tsx